import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import {
  getServiceComponent,
  getPageTitle,
} from '../../utils/conditionalLogic';
import { RESERVE_COMPONENT_LABELS } from '../../constants';

const { serviceInformation } = fullSchema.properties;

const getYesNoUILabel = formData => {
  const component = getServiceComponent(formData);
  if (!component) {
    return 'Are you currently activated?';
  }
  const name = RESERVE_COMPONENT_LABELS[component];
  return `Are you currently activated in the ${name}?`;
};

export default {
  uiSchema: {
    ...titleUI(props =>
      getPageTitle({ ...props, text: 'Current activation in the' }),
    ),
    serviceInformation: {
      federalActivation: {
        currentlyActivated: {
          ...yesNoUI(),
          'ui:options': {
            ...yesNoUI()['ui:options'],
            updateSchema: formData => ({
              title: getYesNoUILabel(formData),
            }),
          },
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['federalActivation'],
        properties: {
          federalActivation: {
            type: 'object',
            required: ['currentlyActivated'],
            properties: {
              currentlyActivated:
                serviceInformation.properties.federalActivation.properties
                  .currentlyActivated,
            },
          },
        },
      },
    },
  },
};
